// extracted by mini-css-extract-plugin
export var container = "_47-0";
export var fallback = "_47-5";
export var fallbackIcon = "_47-6";
export var hidden = "_47-2";
export var image = "_47-3";
export var loaded = "_47-4";
export var placeholder = "_47-1";